/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const ItalianFlagIconSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 3 2"
    width="1.1em"
    height="1.1em"
  >
    <path fill="#008C45" d="M0 0h1v2H0z"/>
    <path fill="#fff" d="M1 0h1v2H1z"/>
    <path fill="#CD212A" d="M2 0h1v2H2z"/>
  </svg>

);

export const ItalianFlagIcon = (props) => (
  <Icon component={ItalianFlagIconSvg} {...props} />
);
